import { CustomActions } from '@cv-invision/cv.component-library.ux';
import { NavUtils } from './nav.utils';
import { SCHEMA_CONFIG } from './schema-config';

export const UserContext = {
	navItems: [
		{
			label: 'Dashboard',
			route: '/',
			icon: 'fa-tachometer-alt',
			module: 'main',
		},
		{
			label: 'Invision',
			route: '/invision',
			icon: 'fa-project-diagram',
			module: 'main',
			title: 'Modules',
		},
		{
			label: 'Dashboard',
			route: '/invision',
			icon: 'fa-tachometer-alt',
			module: 'invision',
		},
		{
			label: 'Orders',
			route: '/',
			icon: 'fa-inbox ',
			module: 'invision',
		},
		{
			label: 'Messages',
			route: '/',
			icon: 'fa-envelope',
			module: 'invision',
		},
		{
			label: 'Quality Assurance',
			route: '/',
			icon: 'fa-check-circle',
			module: 'invision',
		},
		{
			label: 'Intelligence',
			route: '/intelligence',
			icon: 'fa-server',
			module: 'main',
			title: 'Modules',
		},
		{
			label: 'Inbox',
			route: '/intelligence/inbox',
			icon: 'fa-inbox ',
			module: 'intelligence',
			title: 'quality review',
			subTitle: 'Inbox',
			defaultView: true,
		},
		{
			label: 'Dashboard',
			route: '/intelligence/metrics-dashboard',
			icon: 'fa-poll',
			module: 'intelligence',
			title: 'quality review',
			defaultView: true
		},
		{
			label: 'Import',
			route: '/intelligence/import',
			icon: 'fa-file-import',
			module: 'intelligence',
			title: 'Order Management',
			subTitle: 'Import Order',
		},
		{
			label: 'Create',
			route: '/intelligence/create',
			icon: 'fa-circle-plus',
			module: 'intelligence',
			title: 'Order Management',
			subTitle: 'Create Order',
		},
		{
			label: 'Manage Queues',
			route: '/intelligence/manage-queues',
			icon: 'fa-list',
			module: 'intelligence',
			title: 'Order Management',
			value: 'cv-manage-queues',
			defaultView: true
		},
		{
			label: 'Help Center',
			route: null,
			path: 'helpcenter',
			icon: 'far fa-circle-question',
			module: 'intelligence',
			actions:{
				click: CustomActions.OPEN_HELPDESK,
			}
		},
		// Appraisal Desktop
		{
			label: 'Inbox',
			route: '/desktop/inbox',
			icon: 'fa-inbox ',
			module: 'appraisal-desktop',
			title: 'Review',
			subTitle: 'Inbox',
			defaultView: true,
		},
		{
			label: 'Transfer Order',
			route: '/desktop/transfer',
			icon: 'fa-solid fa-arrow-right-arrow-left',
			module: 'appraisal-desktop',
			title: 'Digital Transfer Order Tool',
			subTitle: 'Digital Transfer Order Tool',
			defaultView: true,
			permissions: ['orders:transfers']
		},
		// Identity System
		{
			label: 'User List',
			route: '/identity-system/users',
			icon: 'fa-users',
			module: 'identity-system',
			title: 'User Management',
			subTitle: 'User List',
			defaultView: true,
		},
		{
			label: 'Organizations',
			route: '/identity-system/management/organizations',
			icon: 'fa-sitemap',
			module: 'identity-system',
			title: 'organizations Management',
			subTitle: 'Organizations List',
		},
		{
			label: 'Security Groups',
			route: '/identity-system/management/security-groups',
			icon: 'fa-layer-group',
			module: 'identity-system',
			title: 'Security Groups',
			subTitle: 'Security Groups List',
		},
		// Rule Search
		{
			label: 'Rule Search',
			route: '/rule-engine/rule-search',
			icon: 'fa-magnifying-glass',
			module: 'rule-engine',
			title: 'Rule Search',
			subTitle: 'Rule Search',
			defaultView: true
		},
		// Smart QC
		{
			label: 'Smart QC ',
			route: '/rule-engine/smart-qc',
			icon: 'fa-lightbulb',
			module: 'rule-engine',
			title: 'Smart QC',
			subTitle: 'Smart QC',
			defaultView: true
		},
		// Ticket Manager
		{
			label: 'Rule Ticket Manager',
			route: '/rule-engine/rule-ticket-manager',
			icon: 'fad fa-solid fa-ticket',
			module: 'rule-engine',
			title: 'Rule Ticket Manager',
			subTitle: 'Rule Ticket Manager',
		},
		// Rule Set List
		{
			label: 'Ruleset List',
			route: '/rule-engine/rule-sets',
			icon: 'fa-cogs',
			module: 'rule-engine',
			title: 'Rule Engine',
			subTitle: 'Ruleset List'
		},
		{
			label: 'Ruleset Mapper',
			route: '/rule-engine/rule-set-mappings',
			icon: 'fad fa-folder-tree',
			module: 'rule-engine',
			title: 'RuleSet Management',
			subTitle: 'Ruleset Mapper',
		},
		{
			label: 'Alternative RulesMapper',
			route: '/rule-engine/alternative-rules-mappers',
			icon: 'fad fa-folder-tree',
			module: 'rule-engine',
			title: 'Alternative RulesMapper',
			subTitle: 'Ruleset Mapper',
		},
	],
	schema: [
		{
			type: SCHEMA_CONFIG.CVReview_1004.schema,
			navItems: NavUtils.getSchemaNav(SCHEMA_CONFIG.CVReview_1004.schema),
		},
		{
			type: SCHEMA_CONFIG.CVReview_1073.schema,
			navItems: NavUtils.getSchemaNav(SCHEMA_CONFIG.CVReview_1073.schema),
		},
		{
			type: SCHEMA_CONFIG.CVReview_1075.schema,
			navItems: NavUtils.getSchemaNav(SCHEMA_CONFIG.CVReview_1075.schema),
		},
		{
			type: SCHEMA_CONFIG.CVReview_2055.schema,
			navItems: NavUtils.getSchemaNav(SCHEMA_CONFIG.CVReview_2055.schema),
		},
		{
			type: 'revised',
			navItems: [
				{
					label: 'Revised Fields',
					route: 'intelligence/quality/revisions',
					path: 'revisions',
					basePath: 'intelligence/quality/',
					icon: 'fas fa-check-double',
					isRevised: true,
					module: 'quality',
					badge: '',
				},
			],
		},
		{
			type: SCHEMA_CONFIG.InspectionReport.schema,
			navItems: NavUtils.getSchemaNav(SCHEMA_CONFIG.InspectionReport.schema),
		},
	],
};

export interface UserLogin {
	isActive?: boolean;
	navItems?: any;
	schema?: any;
}
